module.exports = __webpack_public_path__ + "img/saishianpai-icon-4.658ab194.png";